<template>
  <transition name="fade">
    <div class="welcome" v-if="welcomeVisible">
      <div class="welcome-shadow" @click="hideWelcomePopup"></div>
      <div class="welcome-main">
        <a
          href="javascript:;"
          class="welcome-main-close"
          :style="{
            background: getImageUrl(welcomePopupResource.close)
          }"
          style="background-size: 100% 100%"
          @click="hideWelcomePopup"
        ></a>
        <img
          class="welcome-main-img"
          :src="welcomePopupResource.bg"
          object-fit="contain"
        />
        <a
          href="javascript:;"
          class="welcome-main-btn"
          :style="{
            background: getImageUrl(welcomePopupResource.btn)
          }"
          style="background-size: 100% 100%"
          @click="jumpLink(welcomePopupResource.link)"
        ></a>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { clickButton, showPopup } from '@plugins/biPoint/_configWebstoreV2';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
export default {
  name: 'WelfarePopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      welcomeVisible: false
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    ...mapGetters(['gameInfoConfig']),
    welcomePopupResource() {
      return (
        this.gameInfoConfig?.welcomePopupConfig.resource[this.lang] ||
        this.gameInfoConfig?.welcomePopupConfig.resource[this.defaultLang]
      );
    },
    defaultLang() {
      return this.gameInfoConfig?.welcomePopupConfig?.defaultLang || '';
    }
  },
  methods: {
    hideWelcomePopup() {
      this.welcomeVisible = false;
      clickButton({
        btnName: 'close mycard popup',
        locationKey: 'mycardactivity',
      });
    },
    jumpLink(reallyLink) {
      sdkOpenLink({
        link: getGlobalGetGotoLink({link: reallyLink})
      });
      clickButton({
        btnName: 'go_link',
        locationKey: 'mycardactivity',
        otherParams: {
          link: reallyLink,
        }
      });
    },
    getImageUrl(url) {
      return `url(${url}) no-repeat top`;
    }
  },
  created() {
    this.welcomeVisible =
      this.gameInfoConfig?.welcomePopupConfig?.isOpen &&
      (this.gameInfoConfig?.welcomePopupConfig?.resource[this.lang] ||
        this.gameInfoConfig?.welcomePopupConfig?.resource[this.defaultLang]);
    if (this.welcomeVisible) {
      showPopup('mycardactivity');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.welcome {
  z-index: 1001;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    border-radius: 10px;
    &-close {
      width: 32px;
      height: 33px;
      display: block;
      position: absolute;
      right: 0;
      top: 0;
      background-size: 100% 100%;
      cursor: pointer;
    }
    &-img {
      max-width: calc(100vw - 40px);
      object-fit: contain;
    }
    &-btn {
      width: 221px;
      height: 55px;
      display: block;
      position: absolute;
      margin: 0 auto;
      bottom: -21px;
      background-repeat: no-repeat;
      background-position: center;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
}
</style>
